import { IlogisticServiceDetails, LOGISTIC_SERVICE_STATUS_NAME } from '../../../../../types/services';
import LogisticServiceDatesAndProgrammingDetails from './LogisticServiceDatesAndProgrammingDetails/LogisticServiceDatesAndProgrammingDetails';
import { LogisticServiceProviderDetails } from './LogisticServiceProviderDetails';
import DocumentsComponent from './DocumentsComponent/DocumentsComponent';

import './LogisticServiceDetailsTab1General.scss';

const LogisticServiceDetailsTab1General = ({
  logisticServiceData,
  updateDataCallback,
  updateWithoutLoader
}: {
  logisticServiceData: IlogisticServiceDetails;
  updateDataCallback: () => Promise<void>;
  updateWithoutLoader: () => Promise<void>;
}) => {
  const showProviderInfo = [
    LOGISTIC_SERVICE_STATUS_NAME.ACTIVE,
    LOGISTIC_SERVICE_STATUS_NAME.INPROCESS,
    LOGISTIC_SERVICE_STATUS_NAME.DELIVERED
  ].includes((logisticServiceData.statusName as LOGISTIC_SERVICE_STATUS_NAME) || '');

  return (
    <div className="LogisticServiceDetailsTab1General logisticServiceDetailTab1GeneralContainer">
      <LogisticServiceDatesAndProgrammingDetails
        logisticServiceData={logisticServiceData}
        updateDataCallback={updateDataCallback}
      />

      <LogisticServiceProviderDetails
        logisticServiceData={logisticServiceData}
        updateWithoutLoader={updateWithoutLoader}
        showProviderInfo={showProviderInfo}
      />
      <div className="dividerLine" />

      <DocumentsComponent logisticServiceData={logisticServiceData} updateWithLoaders={updateWithoutLoader} />
    </div>
  );
};

export default LogisticServiceDetailsTab1General;
